import { supabase, isConfigured } from './supabase';
import type { ContactAISummary } from '../types';

// ============================================================
// AI SUMMARIES
// ============================================================

export async function getLatestSummary(contactId: string): Promise<ContactAISummary | null> {
  if (!isConfigured) return null;

  const { data, error } = await supabase
    .from('sales_contact_ai_summaries')
    .select('*')
    .eq('contact_id', contactId)
    .order('created_at', { ascending: false })
    .limit(1)
    .single();

  if (error && error.code !== 'PGRST116') {
    console.error('[summaries] getLatestSummary failed:', error);
  }

  return data as ContactAISummary | null;
}

export async function getSummariesForContact(contactId: string): Promise<ContactAISummary[]> {
  if (!isConfigured) return [];

  const { data, error } = await supabase
    .from('sales_contact_ai_summaries')
    .select('*')
    .eq('contact_id', contactId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('[summaries] getSummariesForContact failed:', error);
    return [];
  }

  return data as ContactAISummary[];
}

export async function createSummary(
  contactId: string,
  summary: string,
  needs: string[] = [],
  recommendedMessage: string | null = null,
  createdBy: string | null = null
): Promise<ContactAISummary | null> {
  if (!isConfigured) return null;

  const { data, error } = await supabase
    .from('sales_contact_ai_summaries')
    .insert({
      contact_id: contactId,
      summary,
      needs,
      recommended_message: recommendedMessage,
      created_by: createdBy,
    })
    .select()
    .single();

  if (error) {
    console.error('[summaries] createSummary failed:', error);
    return null;
  }

  return data as ContactAISummary;
}

export async function deleteSummary(id: string): Promise<boolean> {
  if (!isConfigured) return false;

  const { error } = await supabase
    .from('sales_contact_ai_summaries')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('[summaries] deleteSummary failed:', error);
    return false;
  }

  return true;
}

// Note: AI generation can be added here when AI services are available
// For now, summaries are created manually
